/**
 * Section header component with optional "View all" link
 */

import { Button } from "@/components/ui/button";

export interface SectionHeaderProps {
  title: string;
  viewAllHref?: string;
  onViewAll?: () => void;
  testId?: string;
}

export function SectionHeader({
  title,
  viewAllHref,
  onViewAll,
  testId,
}: SectionHeaderProps) {
  const handleViewAll = () => {
    if (onViewAll) {
      onViewAll();
    } else if (viewAllHref) {
      window.location.href = viewAllHref;
    }
  };

  return (
    <div className="flex items-center justify-between mb-4" data-testid={testId}>
      <h2 className="text-lg font-semibold">{title}</h2>
      {(viewAllHref || onViewAll) && (
        <button
          className="text-sm text-primary hover:underline"
          onClick={handleViewAll}
          data-testid={`${testId}-view-all`}
        >
          View all
        </button>
      )}
    </div>
  );
}

